import { theme } from "antd";

import empireLogo from "../../assets/tenants/empiretrust/logo.png";
import citygateLogo from "../../assets/tenants/citygate/logo.png";
import standardlinkLogo from "../../assets/tenants/standardlink/logo.png";
import retrustLogo from "../../assets/tenants/retrust/logo.png";

import empireDarkLogo from "../../assets/tenants/empiretrust/dark-logo.png";
import citygateDarkLogo from "../../assets/tenants/citygate/dark-logo.png";
import standardLinkDarkLogo from "../../assets/tenants/standardlink/dark-logo.png";
import retrustDarkLogo from "../../assets/tenants/retrust/logo.png";

import empireImagebackground from "../../assets/tenants/empiretrust/authImage.jpg";
import citygateImagebackground from "../../assets/tenants/citygate/authImage.jpg";
import standardLinkImagebackground from "../../assets/tenants/standardlink/authImage.png";
import retrustImagebackground from "../../assets/tenants/retrust/authImage.png";
import defaultImagebackground from "../../assets/tenants/default/authImage.jpg";

import empireImagebackgroundDark from "../../assets/tenants/empiretrust/authImageDark.png";
import citygateImagebackgroundDark from "../../assets/tenants/citygate/authImageDark.png";
import standardlinkImagebackgroundDark from "../../assets/tenants/standardlink/authImageDark.png";
import retrustImagebackgroundDark from "../../assets/tenants/retrust/authImage.png";
import defaultImagebackgroundDark from "../../assets/tenants/default/authImageDark.png";

import empireAccountbgImage from "../../assets/tenants/empiretrust/profile_back_img.svg";
import cityAccountbgImage from "../../assets/tenants/citygate/profile_back_img.svg";
import defaultAccountbgImage from "../../assets/tenants/default/profile_back_img.svg";
import { getDomain, getSubdomain } from "../../utils/routes/baseURLRetriver";

// BankLingo default logo - use the SVG from public folder
const defaultLogo = "/banklingo_logo.svg";
const defaultDarkLogo = "/banklingo_logo.svg";

const tenantAssets = {
  citygate: {
    companyName: "City Gate Investment",
    title: "Welcome to City Gate Investment",
    tagLine: "Your Gateway to Wealth Creation.",
    cssName: "citygate",
    theme: {
      colorPrimary: "#e5791b",
      primaryHoverBgColor: "#f9f9f9",
      whiteBgColor: "#FFFFFF",
      textDefaultColor: "#2d3748",
      borderColor: "#d1d1d1",
      iconOutlineStyle: { color: "#e5791b", fontSize: "24px" },
      algorithm: theme.defaultAlgorithm,
    },
    profileBgImage: cityAccountbgImage,
    logo: citygateLogo,
    darkLogo: citygateDarkLogo,
    loginImageBackground: citygateImagebackground,
    loginImageBackgroundDark: citygateImagebackgroundDark,
    support: {
      mobile: "+234 123 456 7890",
      email: "support@banklingo.app",
      webSite: "www.banklingo.app",
      facebook: "https://www.facebook.com/banklingo",
    },
  },
  empiretrust: {
    companyName: "Empire Trust MFB",
    title: "Welcome to Empire Trust MFB",
    tagLine: "Enabling Success Together.",
    cssName: "empiretrust",
    profileBgImage: empireAccountbgImage,
    theme: {
      colorPrimary: "#e5791b",
      primaryHoverBgColor: "#f9f9f9",
      whiteBgColor: "#FFFFFF",
      textDefaultColor: "#2d3748",
      borderColor: "#d1d1d1",
      iconOutlineStyle: { color: "#e5791b", fontSize: "24px" },
      algorithm: theme.darkAlgorithm,
    },
    logo: empireLogo,
    darkLogo: empireDarkLogo,
    loginImageBackground: empireImagebackground,
    loginImageBackgroundDark: empireImagebackgroundDark,
    support: {
      mobile: "+234 123 456 7890",
      email: "support@banklingo.app",
      webSite: "www.banklingo.app",
      facebook: "https://www.facebook.com/banklingo",
    },
  },
  standardlink: {
    companyName: "Standard Link",
    title: "Welcome to Standard Link",
    tagLine: "...linking you to greater height",
    cssName: "standardlink",
    profileBgImage: empireAccountbgImage,
    theme: {
      colorPrimary: "#03aa98",
      primaryHoverBgColor: "#f9f9f9",
      whiteBgColor: "#FFFFFF",
      textDefaultColor: "#2d3748",
      borderColor: "#d1d1d1",
      iconOutlineStyle: { color: "#03aa98", fontSize: "24px" },
      algorithm: theme.darkAlgorithm,
    },
    logo: standardlinkLogo,
    darkLogo: standardLinkDarkLogo,
    loginImageBackground: standardLinkImagebackground,
    loginImageBackgroundDark: standardlinkImagebackgroundDark,
    support: {
      mobile: "+234 803 970 0147",
      email: "support@banklingo.app",
      webSite: "www.banklingo.app",
      facebook: "https://www.facebook.com/banklingo",
    },
  },
  retrust: {
    companyName: "Retrust",
    title: "Welcome to Retrust",
    tagLine: "Building a Brighter Financial Future",
    cssName: "retrust",
    profileBgImage: empireAccountbgImage,
    theme: {
      colorPrimary: "#e20f00",
      primaryHoverBgColor: "#f9f9f9",
      whiteBgColor: "#FFFFFF",
      textDefaultColor: "#2d3748",
      borderColor: "#d1d1d1",
      iconOutlineStyle: { color: "#e20f00", fontSize: "24px" },
      algorithm: theme.darkAlgorithm,
    },
    logo: retrustLogo,
    darkLogo: retrustDarkLogo,
    loginImageBackground: retrustImagebackground,
    loginImageBackgroundDark: retrustImagebackgroundDark,
    support: {
      mobile: "+234 9012345678",
      email: "info@Retrustmfb.com",
      webSite: "www.retrustmfb.com",
      facebook: "https://www.facebook.com/banklingo",
    },
  },
  default: {
    companyName: "Default Tenant",
    tagLine: "This is our development environment.",
    title: "Welcome to Default Tenant",
    cssName: "default",
    theme: {
      colorPrimary: "#008751",
      primaryHoverBgColor: "#f9f9f9",
      whiteBgColor: "#f9f9f9",
      textDefaultColor: "#2d3748",
      borderColor: "#d1d1d1",
      iconOutlineStyle: { color: "#008751", fontSize: "24px" },
      algorithm: theme.darkAlgorithm,
    },
    logo: defaultLogo,
    profileBgImage: defaultAccountbgImage,
    darkLogo: defaultDarkLogo,
    loginImageBackground: defaultImagebackground,
    loginImageBackgroundDark: defaultImagebackgroundDark,
    support: {
      mobile: "+234 123 456 7890",
      email: "support@banklingo.app",
      webSite: "www.banklingo.app",
      facebook: "https://www.facebook.com/banklingo",
    },
  },
};
const getTenant = () => {
  // Check for development override first
  if (process.env.NODE_ENV === "development") {
    const devOverride = localStorage.getItem("dev_tenant_override");
    if (devOverride && tenantAssets[devOverride]) {
      console.log("[Tenant Resolver] Using DEV override:", devOverride);
      return tenantAssets[devOverride];
    }
  }

  const subdomain = getSubdomain()?.toLowerCase();
  const domain = getDomain()?.toLowerCase();

  const domainToTenant = {
    "ibank.standardlinkcontinental.com": "standardlink",
    "banklingo.standardlinkcontinental.com": "standardlink",
    "empiretrust.banklingo.app": "empiretrust",
    "citygate.banklingo.app": "citygate",
    "onlineloan.citygateglobal.com": "citygate",
    "ibank.empiretrustmfb.com": "empiretrust",
    "banklingo.empiretrustmfb.com": "empiretrust",
  };

  let tenantKey = tenantAssets[subdomain] ? subdomain : null;

  if (!tenantKey && domainToTenant[domain]) {
    tenantKey = domainToTenant[domain];
  }

  const tenant = tenantAssets[tenantKey] || tenantAssets.default;

  if (process.env.NODE_ENV === "development") {
    console.log("[Tenant Resolver]", { subdomain, domain, tenantKey });
  }

  return tenant;
};

export { getTenant, tenantAssets };

export const getApiBaseUrl = () => {
  const hostname = window.location.hostname.toLowerCase();

  // Check for development override
  if (process.env.NODE_ENV === "development") {
    const devOverride = localStorage.getItem("dev_tenant_override");
    if (devOverride) {
      console.log("[API URL Resolver] Using DEV tenant override:", devOverride);

      // Map tenant to their API URLs
      const tenantApiUrls = {
        standardlink:
          "https://banklingoapi.standardlinkcontinental.com/Fintech.CBS.Backend",
        empiretrust:
          "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend",
        citygate:
          "https://banklingoapi.citygateglobal.com/Prod.Fintech.CBS.Backend",
        retrust:
          "https://platform-sandbox-api.banklingo.app/Fintech.CBS.Backend",
        default: "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend",
      };

      const apiUrl = tenantApiUrls[devOverride] || tenantApiUrls["default"];
      console.log("[API URL Resolver] Resolved API URL:", apiUrl);
      return apiUrl;
    }
  }

  const apiUrls = {
    "banklingo.standardlinkcontinental.com":
      "https://banklingoapi.standardlinkcontinental.com/Fintech.CBS.Backend",
    "ibank.standardlinkcontinental.com":
      "https://banklingoapi.standardlinkcontinental.com/Fintech.CBS.Backend",
    "empiretrust.example.com":
      "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend",
    "citygate.example.com":
      "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend",
    "ibank.empiretrustmfb.com":
      "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend",
    "banklingo.empiretrustmfb.com":
      "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend",
    "onlineloan.citygateglobal.com":
      "https://banklingoapi.citygateglobal.com/Prod.Fintech.CBS.Backend",
    default:
      // "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend",
      "https://platform-sandbox-api.banklingo.app/Fintech.CBS.Backend",
    // "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend",
  };

  const apiUrl = apiUrls[hostname] || apiUrls["default"];
  console.log("[API URL Resolver]", { hostname, apiUrl });
  return apiUrl;
};

export const getWebSocketUrl = () => {
  const hostname = window.location.hostname.toLowerCase();

  // Check for development override
  if (process.env.NODE_ENV === "development") {
    const devOverride = localStorage.getItem("dev_tenant_override");
    if (devOverride) {
      console.log(
        "[WebSocket URL Resolver] Using DEV tenant override:",
        devOverride,
      );

      // Map tenant to their WebSocket URLs
      const tenantWebSocketUrls = {
        standardlink:
          "https://banklingoapi.standardlinkcontinental.com/Fintech.CBS.Backend/notificationHub",
        empiretrust:
          "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend/notificationHub",
        citygate:
          "https://banklingoapi.citygateglobal.com/Prod.Fintech.CBS.Backend/notificationHub",
        retrust:
          "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend/notificationHub",
        default:
          "https://platform-sandbox-api.banklingo.app/Fintech.CBS.Backend/notificationHub",
        // "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend/notificationHub",
      };

      const wsUrl =
        tenantWebSocketUrls[devOverride] || tenantWebSocketUrls["default"];
      console.log("[WebSocket URL Resolver] Resolved WebSocket URL:", wsUrl);
      return wsUrl;
    }
  }

  const webSocketUrls = {
    "ibank.standardlinkcontinental.com":
      "https://banklingoapi.standardlinkcontinental.com/Fintech.CBS.Backend/notificationHub",
    "banklingo.standardlinkcontinental.com":
      "https://banklingoapi.standardlinkcontinental.com/Fintech.CBS.Backend/notificationHub",
    "empiretrust.example.com":
      "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend/notificationHub",
    "citygate.example.com":
      "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend/notificationHub",
    "ibank.empiretrustmfb.com":
      "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend/notificationHub",
    "banklingo.empiretrustmfb.com":
      "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend/notificationHub",
    "onlineloan.citygateglobal.com":
      "https://banklingoapi.citygateglobal.com/Prod.Fintech.CBS.Backend/notificationHub",
    default:
      "https://platform-sandbox-api.banklingo.app/Fintech.CBS.Backend/notificationHub",
    // "https://cb-api-sandbox.banklingo.app/Fintech.CBS.Backend/notificationHub",
    // "https://banklingoapi.empiretrustmfb.com/Prod.Fintech.CBS.Backend/notificationHub",
  };

  const wsUrl = webSocketUrls[hostname] || webSocketUrls["default"];
  console.log("[WebSocket URL Resolver]", { hostname, wsUrl });
  return wsUrl;
};
